export default __webpack_public_path__ + "img/fleet-views.44b7ea98.png";